import React from "react";
import { connect } from "react-redux";
import { SetMethodCodeActive, } from '$Deposits/store/actions/DepositAction'




class AvailableMethods extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }



    render() {

        const {
            MethodsActive,
            MethodCodeActive,
            SetMethodCodeActive,
            AvailableMethods,
            CTC,
        } = this.props

        const { code, availableMethods = [], } = MethodsActive || {}

        //去掉DEFAULT，还有就显示
        let methodsList = availableMethods.filter((v) => { return v.methodCode != 'DEFAULT' }) || []
        if (code == 'LB') {
            //LB有UniqueAmt显示渠道
            methodsList = availableMethods.filter((v) => { return v.methodCode == 'UniqueAmt' }) || []
        }

        return (
            <>
                {
                    // FP5-809 FP5-723 只有FP 有充值渠道
                    code != 'CTC' &&  
                    <AvailableMethods
                        methodCode={MethodCodeActive}
                        availableMethods={methodsList}
                        onChange={(methodCode) => { SetMethodCodeActive(methodCode, code) }}
                    />
                }
                {
                    code == 'CTC' &&
                    <CTC
                        methodCode={MethodCodeActive}
                        availableMethods={methodsList}
                        onChange={(methodCode) => { SetMethodCodeActive(methodCode, code) }}
                    />
                }
            </>
        );
    }
}


const mapStateToProps = state => ({
    MethodCodeActive: state.MethodCodeActive,
    MethodsActive: state.MethodsActive,
});
const mapDispatchToProps = {
    SetMethodCodeActive: (code, data) => SetMethodCodeActive(code, data),
};
export default connect(mapStateToProps, mapDispatchToProps)(AvailableMethods);


